/** استایل‌های مشترک صفحات گزارش، نمایش و ثبت اطلاعات */
import { colors } from './colors';

export const PRIMARY = colors.primary;
export const PRIMARY_DARK = colors.primaryHover;
export const PRIMARY_LIGHT = colors.success;
export const TEXT_PRIMARY = colors.text;
export const TEXT_SECONDARY = colors.textMuted;
export const TEXT_MUTED = colors.placeholder;

export const PAGE_BG_SX = {
  minHeight: '100vh',
  width: '100%',
  maxWidth: '100%',
  background: 'linear-gradient(180deg, #f7f8fa 0%, #e5f4ff 50%, #f7f8fa 100%)',
  pb: 4,
  px: { xs: 1.5, sm: 2, md: 3 },
  boxSizing: 'border-box',
};

export const HERO_SX = {
  mt: 1,
  mb: 3,
  p: { xs: 2.5, md: 3.5 },
  borderRadius: 4,
  background: 'linear-gradient(135deg, #037f4c 0%, #00a86a 50%, #00c875 100%)',
  color: 'white',
  boxShadow: '0 20px 60px rgba(50, 51, 56, 0.35)',
  position: 'relative',
  overflow: 'hidden',
};

export const HERO_DECOR_1_SX = {
  position: 'absolute',
  top: -40,
  left: -40,
  width: 200,
  height: 200,
  borderRadius: '50%',
  bgcolor: 'rgba(255,255,255,0.08)',
};

export const HERO_DECOR_2_SX = {
  position: 'absolute',
  bottom: -60,
  right: -20,
  width: 260,
  height: 260,
  borderRadius: '50%',
  bgcolor: 'rgba(255,255,255,0.05)',
};

export const HERO_CHIP_SX = {
  bgcolor: 'rgba(255,255,255,0.18)',
  color: 'white',
  fontWeight: 600,
};

export const CARD_SX = {
  borderRadius: 3,
  border: '1px solid rgba(50, 51, 56, 0.1)',
  boxShadow: '0 8px 32px rgba(50, 51, 56, 0.06)',
  bgcolor: 'rgba(255,255,255,0.95)',
  backdropFilter: 'blur(8px)',
  overflow: 'hidden',
};

export const SECTION_TITLE_SX = {
  fontWeight: 800,
  color: TEXT_PRIMARY,
};

export const FILTER_SECTION_SX = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2.5,
  bgcolor: '#f7f8fa',
  border: '1px solid #e6e9ef',
  direction: 'rtl',
  textAlign: 'right',
};

export const FILTER_INLINE_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  direction: 'rtl',
  width: '100%',
  minWidth: 0,
};

export const FILTER_INLINE_LABEL_SX = {
  fontWeight: 700,
  color: TEXT_SECONDARY,
  whiteSpace: 'nowrap',
  flexShrink: 0,
  fontSize: '0.875rem',
};

export const FILTER_GRID_DATES = {
  display: 'grid',
  gap: 2,
  direction: 'rtl',
  justifyContent: 'start',
  gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
};

export const FILTER_GRID_SELECTS = {
  display: 'grid',
  gap: 2,
  direction: 'rtl',
  justifyContent: 'start',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(3, minmax(0, 1fr))',
    lg: 'repeat(5, minmax(0, 1fr))',
  },
};

export const FILTER_GRID_EXTRA = {
  display: 'grid',
  gap: 2,
  direction: 'rtl',
  gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', md: 'repeat(3, minmax(0, 1fr))' },
};

export const DATE_PICKER_SLOT_PROPS = {
  textField: {
    size: 'small',
    fullWidth: true,
    placeholder: 'روز / ماه / سال',
    sx: {
      flex: 1,
      minWidth: 0,
      '& .MuiOutlinedInput-root': {
        direction: 'rtl',
        pr: 1.5,
        pl: 5,
        borderRadius: 2,
        bgcolor: '#fff',
        '& fieldset': { borderColor: '#e6e9ef' },
        '&:hover fieldset': { borderColor: PRIMARY_LIGHT },
        '&.Mui-focused fieldset': { borderColor: PRIMARY },
      },
      '& .MuiInputBase-input': { cursor: 'pointer', textAlign: 'right' },
      '& .MuiInputAdornment-root': {
        position: 'absolute',
        left: 8,
        right: 'auto',
        margin: 0,
      },
    },
  },
};

export const FILTER_CAPTION_SX = {
  display: 'block',
  mb: 1.5,
  fontWeight: 700,
  color: TEXT_SECONDARY,
};

export const FILTER_TEXT_INPUT_SX = {
  flex: 1,
  minWidth: 0,
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    bgcolor: '#fff',
    direction: 'rtl',
    '& fieldset': { borderColor: '#e6e9ef' },
    '&:hover fieldset': { borderColor: PRIMARY_LIGHT },
    '&.Mui-focused fieldset': { borderColor: PRIMARY },
  },
  '& .MuiInputBase-input': { textAlign: 'right' },
};

export const FILTER_GRID_SX = {
  display: 'grid',
  gap: 2,
  direction: 'rtl',
  justifyContent: 'start',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(3, minmax(0, 1fr))',
  },
};

export const FORM_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  mb: 2,
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2.5,
  bgcolor: '#f7f8fa',
  border: '1px solid #e6e9ef',
  direction: 'rtl',
};

export const FORM_ROW_MULTILINE_SX = {
  ...FORM_ROW_SX,
  alignItems: 'flex-start',
  mb: 2.5,
};

export const FORM_LABEL_SX = {
  minWidth: { xs: 90, sm: 120 },
  fontWeight: 700,
  color: TEXT_SECONDARY,
  fontSize: '0.875rem',
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

export const INPUT_OUTLINED_SX = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    bgcolor: '#fff',
    direction: 'rtl',
    '& fieldset': { borderColor: '#e6e9ef' },
    '&:hover fieldset': { borderColor: PRIMARY_LIGHT },
    '&.Mui-focused fieldset': { borderColor: PRIMARY },
  },
  '& .MuiInputBase-input': { textAlign: 'right' },
  '& .MuiSelect-select': { textAlign: 'right' },
};

export const SELECT_FIELD_SX = {
  flex: 1,
  ...INPUT_OUTLINED_SX,
};

export const TEXT_FIELD_SX = {
  flex: 1,
  ...INPUT_OUTLINED_SX,
};

export const SEARCH_FIELD_SX = {
  flex: 1,
  minWidth: 280,
  ...INPUT_OUTLINED_SX,
  '& .MuiOutlinedInput-root': {
    ...INPUT_OUTLINED_SX['& .MuiOutlinedInput-root'],
    pl: 1,
  },
};

export const ACTION_BAR_SX = {
  display: 'flex',
  gap: 1.5,
  alignItems: 'center',
  flexWrap: 'wrap',
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2.5,
  bgcolor: '#f7f8fa',
  border: '1px solid #e6e9ef',
  direction: 'rtl',
};

export const BTN_OUTLINED_SX = {
  borderRadius: 2,
  borderColor: PRIMARY,
  color: PRIMARY_DARK,
  fontWeight: 700,
  textTransform: 'none',
  '&:hover': {
    borderColor: PRIMARY_DARK,
    bgcolor: 'rgba(50, 51, 56, 0.06)',
  },
};

export const BTN_CONTAINED_SX = {
  borderRadius: 2,
  fontWeight: 700,
  textTransform: 'none',
  bgcolor: PRIMARY_DARK,
  boxShadow: '0 4px 14px rgba(50, 51, 56, 0.35)',
  '&:hover': {
    bgcolor: '#037f4c',
    boxShadow: '0 6px 20px rgba(50, 51, 56, 0.4)',
  },
};

export const BTN_HERO_SX = {
  bgcolor: 'rgba(255,255,255,0.2)',
  backdropFilter: 'blur(8px)',
  fontWeight: 700,
  borderRadius: 2,
  color: 'white',
  textTransform: 'none',
  '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
};

export const BTN_SUCCESS_SX = {
  borderRadius: 2,
  borderColor: '#00a86a',
  color: '#037f4c',
  fontWeight: 700,
  textTransform: 'none',
  '&:hover': { borderColor: '#037f4c', bgcolor: 'rgba(0, 168, 106, 0.06)' },
};

export const BTN_DANGER_SX = {
  borderRadius: 2,
  fontWeight: 700,
  textTransform: 'none',
  bgcolor: '#e44258',
  '&:hover': { bgcolor: '#c9364a' },
};

export const TABLE_HEADER_BOX_SX = {
  bgcolor: '#f7f8fa',
  borderBottom: '1px solid #e6e9ef',
  p: 2,
};

export const TABLE_HEAD_CELL_SX = {
  fontWeight: 800,
  color: TEXT_PRIMARY,
  textAlign: 'center',
  fontSize: '0.8rem',
};

export const tableRowSx = (index) => ({
  display: 'grid',
  gap: 2,
  alignItems: 'center',
  p: 2,
  borderBottom: '1px solid #e6e9ef',
  bgcolor: index % 2 === 0 ? 'rgba(248, 250, 252, 0.6)' : '#fff',
  transition: 'background 0.15s, box-shadow 0.15s',
  '&:hover': {
    bgcolor: 'rgba(50, 51, 56, 0.04)',
    boxShadow: '0 2px 8px rgba(50, 51, 56, 0.04)',
  },
});

export const TABLE_BODY_CELL_SX = {
  textAlign: 'center',
  color: '#323338',
  fontWeight: 500,
  fontSize: '0.85rem',
};

export const BADGE_SX = (bg, color) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  bgcolor: bg,
  color,
  px: 1.5,
  py: 0.5,
  borderRadius: 2,
  fontSize: '0.75rem',
  fontWeight: 700,
});

export const ASSAY_BADGE_SX = BADGE_SX('#e5f4ff', PRIMARY_DARK);

export const DIALOG_PAPER_SX = {
  borderRadius: 3,
  border: '1px solid rgba(50, 51, 56, 0.1)',
  boxShadow: '0 20px 60px rgba(50, 51, 56, 0.12)',
  overflow: 'hidden',
};

export const DIALOG_TITLE_SX = {
  fontWeight: 800,
  color: TEXT_PRIMARY,
  textAlign: 'center',
  borderBottom: '1px solid #e6e9ef',
  bgcolor: '#f7f8fa',
};

export const LOADING_BOX_SX = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 2,
  minHeight: '60vh',
};

export const PAGINATION_BAR_SX = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 2,
  p: 2,
  borderRadius: 2.5,
  bgcolor: '#f7f8fa',
  border: '1px solid #e6e9ef',
};

export const PAGE_INDICATOR_SX = {
  fontWeight: 700,
  color: TEXT_PRIMARY,
  px: 2.5,
  py: 1,
  bgcolor: 'rgba(50, 51, 56, 0.08)',
  borderRadius: 2,
  border: '1px solid rgba(50, 51, 56, 0.15)',
};
